// The Alchemy Village - Content Data

export const images = {
  treeOfLife: "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/bc4plj5c_Alchemy%20Village%20Tree%20of%20Life.png",
  lectureHall: "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/di57py93_Cabrini%20teaching%20the%20LAW%20.png",
  kitchen: "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/dburvq7u_Gangstachefs%20Kitchen%20for%20website%20.png",
  recordingStudio: "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/jg8wiima_TAM%20Studio%20.png",
  podcastStudio: "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/zsrzy0yi_Cabrinis%20Podcast%20studio%20.png",
  meditation: "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/2nssoq4z_meditation%20room%20at%20Alchemy%20Village%20.png",
  bookCover: "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/qellk8wj_Book%20cover%20How%20to%20say%20FUCK%20THATT%20and%20take%20your%20Life%20Back...%20.png",
};

export const threshold = {
  prelude: ["You are not lost.", "You are at the threshold."],
  title: "The Alchemy Village",
  subtext: "A place where people close the gap in their soul and learn how to create a life that actually matters.",
  cta: "Enter the Village",
  footNote: "Pause long enough to hear the God in YOU direct your path.",
};

export const welcome = {
  heading: "Welcome to The Alchemy Village",
  videoPlaceholder: true,
  endingLine: "Welcome to YOU.",
  cta: "Who AM I... The QUIZ",
};

export const quiz = {
  title: "Who AM I... The QUIZ",
  description: "Before you create a life that actually matters, discover where you are right now.",
  questions: [
    {
      id: 1,
      text: "When you wake up in the morning, what is the first thing you feel?",
      options: [
        { text: "Restless energy — like I need to DO something", archetype: "awakener" },
        { text: "A quiet longing — like something is missing", archetype: "seeker" },
        { text: "Creative fire — ideas I haven't acted on", archetype: "creator" },
        { text: "Heaviness — from a story I keep carrying", archetype: "storyteller" },
      ],
    },
    {
      id: 2,
      text: "What scares you the most right now?",
      options: [
        { text: "That I've been sleepwalking through my own life", archetype: "awakener" },
        { text: "That I don't know what I actually want", archetype: "seeker" },
        { text: "That I'll never create what I'm meant to create", archetype: "creator" },
        { text: "That the fear will never go away", archetype: "warrior" },
      ],
    },
    {
      id: 3,
      text: "When someone asks 'How are you?', what do you really want to say?",
      options: [
        { text: "I'm tired of pretending", archetype: "storyteller" },
        { text: "I'm searching for something deeper", archetype: "healer" },
        { text: "I'm ready for a change but don't know where to start", archetype: "seeker" },
        { text: "I'm done being afraid", archetype: "warrior" },
      ],
    },
    {
      id: 4,
      text: "What would you do if nobody was watching and nothing could fail?",
      options: [
        { text: "Burn my old life down and start over", archetype: "awakener" },
        { text: "Travel inward — sit in silence until the answers come", archetype: "healer" },
        { text: "Build something with my hands — cook, create, make", archetype: "creator" },
        { text: "Tell the truth about everything", archetype: "storyteller" },
      ],
    },
    {
      id: 5,
      text: "What has been stopping you from living the life you want?",
      options: [
        { text: "I don't know what I truly want yet", archetype: "seeker" },
        { text: "Fear of failing... again", archetype: "warrior" },
        { text: "I keep taking care of everyone else", archetype: "healer" },
        { text: "A story from my past that won't let go", archetype: "storyteller" },
      ],
    },
    {
      id: 6,
      text: "Which of these feels most like home?",
      options: [
        { text: "A kitchen full of warmth, music, and real food", archetype: "creator" },
        { text: "A fire circle under the stars with people who see me", archetype: "storyteller" },
        { text: "A quiet room where I can finally hear myself think", archetype: "healer" },
        { text: "A mountaintop where I can see everything clearly", archetype: "awakener" },
      ],
    },
    {
      id: 7,
      text: "What do you want to feel when you leave this place?",
      options: [
        { text: "Awake — like I finally see the truth", archetype: "awakener" },
        { text: "Clear — like I know my next step", archetype: "seeker" },
        { text: "Brave — like the fear doesn't own me anymore", archetype: "warrior" },
        { text: "Free — like I can finally let go of the old story", archetype: "storyteller" },
      ],
    },
  ],
  archetypes: {
    awakener: {
      name: "The Awakener",
      tagline: "The one who sees what others have not yet realized.",
      description: "Awakeners carry a natural awareness of truth. They feel when something in life is out of alignment, when people are living smaller than they were meant to live, or when the story someone is telling themselves simply isn't true.\n\nBecause of this, Awakeners often become catalysts for change. Their presence can spark insight, reflection, and sometimes uncomfortable honesty that ultimately leads to growth.\n\nBeing an Awakener on the journey of Becoming means learning how to use your awareness with wisdom and compassion.",
      gift: "Illumination — helping people see what has been hidden.",
      challenge: "Remembering that awakening begins within.",
      closing: "When an Awakener embraces their role fully, they help others rise into clarity, truth, and personal responsibility.",
      suggestedPath: "/path/fuck-thatt",
      pathName: "The Path to F.U.C.K. T.H.A.T.T.",
    },
    seeker: {
      name: "The Seeker",
      tagline: "The one who knows there is more to life than what they have been told.",
      description: "Seekers are naturally curious about the deeper meaning of existence. They ask questions others may avoid. They feel drawn toward learning, spiritual exploration, self-discovery, and understanding the unseen forces that shape our lives.\n\nA Seeker is not satisfied with surface answers. They want to know why things happen and what life is really asking of them.\n\nBeing a Seeker on the journey of Becoming means honoring the sacred curiosity that lives within you.",
      gift: "Your willingness to explore.",
      challenge: "Remembering that the answers you seek are often already within you.",
      closing: "When a Seeker learns to trust their inner guidance, their search transforms into wisdom — and that wisdom becomes a guiding light for others.",
      suggestedPath: "/path/life-shopping",
      pathName: "The Life-Shopping Path",
    },
    creator: {
      name: "The Creator",
      tagline: "A visionary of possibility.",
      description: "Creators see life not as something that simply happens to them, but as something that can be shaped, designed, and brought into existence. They are naturally drawn to building, imagining, and expressing ideas that did not exist before they touched them.\n\nA Creator understands — sometimes instinctively and sometimes through hard-earned wisdom — that thoughts become things. They feel a deep pull to make something meaningful out of their experiences, whether that comes through art, business, music, teaching, or simply the way they design their life.\n\nBeing a Creator on the journey of Becoming means recognizing that your life itself is your greatest masterpiece.",
      gift: "The ability to turn vision into reality.",
      challenge: "Remembering that you are powerful enough to begin.",
      closing: "When a Creator trusts their voice and chooses to act, they don't just change their own life — they open doors for others to imagine new possibilities too.",
      suggestedPath: "/path/gangstachef",
      pathName: "The GangstaChef's Kitchen Path",
    },
    warrior: {
      name: "The Warrior",
      tagline: "The one who refuses to surrender their power.",
      description: "Warriors are forged through experience. They are people who have faced adversity, challenges, and moments where giving up would have been easier — yet something inside them chose to stand back up.\n\nThe Warrior archetype carries courage, resilience, and determination. They are protectors of truth and champions of personal responsibility.\n\nBeing a Warrior on the journey of Becoming means recognizing that your struggles were not meant to break you — they were meant to reveal your strength.",
      gift: "Your courage.",
      challenge: "Remembering that strength also includes softness and wisdom.",
      closing: "When a Warrior learns to direct their power with purpose, they become a force that inspires others to rise as well.",
      suggestedPath: "/path/fear",
      pathName: "The F.E.A.R. Path",
    },
    healer: {
      name: "The Healer",
      tagline: "The one who understands the power of compassion and restoration.",
      description: "Healers feel deeply. They naturally sense the emotional and spiritual needs of others and often feel called to help bring balance where there has been pain or disconnection.\n\nMany Healers become who they are because they have walked through their own healing journey. Their empathy is born from lived experience.\n\nBeing a Healer on the journey of Becoming means honoring your ability to nurture, guide, and uplift others — while remembering that your own healing matters too.",
      gift: "Your heart.",
      challenge: "Remembering that you cannot pour from an empty cup.",
      closing: "When a Healer learns to care for themselves as deeply as they care for others, their presence becomes a sanctuary for transformation.",
      suggestedPath: "/path/me-treat",
      pathName: "The ME-Treat Path",
    },
    storyteller: {
      name: "The Storyteller",
      tagline: "The keeper of meaning.",
      description: "Storytellers understand that stories shape the way people see themselves and the world around them. They feel drawn to sharing experiences, wisdom, lessons, and truths that help others make sense of their own journey.\n\nWhether through speaking, writing, music, teaching, or conversation, Storytellers help turn lived experiences into understanding.\n\nBeing a Storyteller on the journey of Becoming means realizing that your life experiences are not random — they are chapters in a message that can guide others.",
      gift: "Your voice.",
      challenge: "Trusting that your story matters.",
      closing: "When a Storyteller speaks authentically, they give others permission to see their own lives differently.",
      suggestedPath: "/path/fire-circle",
      pathName: "The Fire Circle Path",
    },
  },
};

export const paths = [
  {
    id: "fuck-thatt",
    route: "/path/fuck-thatt",
    name: "The Path to F.U.C.K. T.H.A.T.T.",
    subtitle: "Finally Understanding Common Knowledge — Things Happen All The Time.",
    message: "This is where you WAKE UP from your dream.\nStop SLEEP-WALKING in your life.",
    purpose: "Teaching Cabrini's philosophy.",
    image: null,
    placeholders: ["3 Core Questions", "5 Principles", "Teaching Videos"],
    color: "#D4AF37",
  },
  {
    id: "life-shopping",
    route: "/path/life-shopping",
    name: "The Life-Shopping Path",
    subtitle: null,
    message: "Most people shop for things.\nHere you shop for THINGS THAT MATTER.",
    purpose: "Clarity exercises.",
    image: null,
    placeholders: ["Digital Experience", "Clarity Course"],
    color: "#C9A84C",
  },
  {
    id: "gangstachef",
    route: "/path/gangstachef",
    name: "The GangstaChef's Kitchen Path",
    subtitle: "Feeding your Mind. Body. Soul.",
    message: "You'll fall in LOVE with yourself in your\nOWN DAMN Kitchen.",
    purpose: "Nourishment of mind, body, and soul.",
    image: null,
    placeholders: ["Cooking Philosophy", "Workshops", "Digital Cooking Experiences"],
    color: "#E8A849",
  },
  {
    id: "fear",
    route: "/path/fear",
    name: "The F.E.A.R. Path",
    subtitle: "Face Everything And Rise",
    message: "It's time to face your fears.",
    purpose: "Overcoming fear and building courage.",
    image: null,
    placeholders: ["Fear Exercises", "Mindset Teachings"],
    color: "#B8860B",
  },
  {
    id: "me-treat",
    route: "/path/me-treat",
    name: "The ME-Treat Path",
    subtitle: "A Retreat to ME.",
    message: "This is where you connect to the\nGod in YOU..",
    purpose: "Retreats and inner connection.",
    image: null,
    placeholders: ["Workshops", "Retreats", "Virtual Experiences"],
    color: "#DAA520",
  },
  {
    id: "fire-circle",
    route: "/path/fire-circle",
    name: "The Fire Circle Path",
    subtitle: null,
    message: "This is where you tell YOUR story that brought you to\nThe Alchemy Village...",
    quote: "\"You can't get to what you WANT by always talking about where you ARE.\nTell the STORY you WANT\" ~ Cabrini",
    purpose: "Release the old story. Begin writing the one you want.",
    image: null,
    placeholders: ["Community Circle", "Story Release Ceremony"],
    color: "#CD853F",
  },
];

export const communityName = "Village Manifestors";
